function updateItem($this) {
  var $parent = $this.parents(".jsItem");
  var qty = Number($parent.find(".jsItemQty").val());
  var vid = Number($parent.data("product-id"));
  var stringUpdate = "updates[" + vid + "]=" + qty;

  if (qty >= 0) {
    // VI Subs: Ensure cart/update.js JSON isn't evaluated as script by jQuery
    $.post(
      window.Shopify.routes.root + "cart/update.js",
      stringUpdate,
      null,
      "json",
    );
    setTimeout(function () {
      $.get("/cart").done(function (data) {
        var newContent = $(data).find("#jsCartContent").contents();
        $("#jsCartContent").empty().append(newContent);
        var $thisItem = $("#jsCartContent").find(
          '.jsItem[data-product-id="' + vid + '"]',
        );
        $thisItem.addClass("success");
        setTimeout(function () {
          $thisItem.removeClass("success");
        }, 1000);
      });
    }, 500);
  } else {
    removeItem($this);
  }
}

function removeItem($this) {
  var removeUrl = $this.data("url");
  var $parent = $this.parents(".jsItem");
  var pTitle = $parent.find(".title").text();
  var pUrl = $parent.find(".title a").prop("href");

  var msg =
    '<div class="cartItem reconsider warning"><strong>' +
    pTitle +
    '</strong> has been removed from cart. <a href="' +
    pUrl +
    '">Reconsider</a></div>';
  console.log(msg);
  $.get(removeUrl).done(function (data) {
    var newContent = $(data).find("#jsCartContent").contents();
    $("#jsCartContent").empty().append(newContent);
    $("#jsCartContent #cartItems").append(msg);
  });
}

function goToCheckout() {
  $("html").on("click", ".jsBtnCheckout", function () {
    if ($("#jsCheckTerms").is(":checked")) {
      $(".jsCartForm").submit();
    } else {
      $("#jsFormCheckbox").addClass("warning");
      return false;
    }
  });
}

// FOR CHAT ADD-ON POPUP STARTS HERE
function checkCartItemALDTR() {
  if ($("#jsHasALDTR").length > 0) {
    var check_ALDTR_cookie = $.cookie("ALDTR-CHAT");
    if (check_ALDTR_cookie != "refuse") {
      init_chataddon_popup();
      $("#jsAddOnPopup-lineitem-offer").addClass("d-none");
    } else {
      $("#jsAddOnPopup-lineitem-offer").removeClass("d-none");
    }
  }

  $("html").on("click", "#jsAddOnPopup-lineitem-offer-btn", function () {
    init_chataddon_popup();
  });
}

function init_chataddon_popup() {
  $.get(
    "https://verifiedinvesting.com/products/apex-live-day-trading-room-chat-add-on?view=popup",
  ).done(function (data) {
    $(data).appendTo("#jsCartContent");
  });
}

function chataddon_popup() {
  $("html").on("click", "#jsAddOnPopup-refuse", function () {
    $("#jsAddOnPopup").remove();
    $.cookie("ALDTR-CHAT", "refuse");
  });

  $("html").on("click", "#jsAddOnPopup-bg", function (e) {
    var $container = $("#jsAddOnPopup-content");
    if (!$container.is(e.target) && $container.has(e.target).length === 0) {
      $("#jsAddOnPopup-refuse").click();
    }
  });

  $("html").on("click", "#jsAddOnPopup-addtocart", function () {
    if ($("#jsAddOnPopup-checkbox").is(":checked")) {
      $("#jsAddOnPopup-form").submit();
      $.cookie("ALDTR-CHAT", "refuse");
    } else {
      $("#jsAddOnPopup-checkbox-block").addClass("warning");
      return false;
    }
  });
}

function checkTradeAlertsExplorer() {
  $(".jsItem").each(function () {
    if (
      $(this).data("variant-id") == 42266891386969 ||
      $(this).data("variant-id") == 42266892107865 ||
      $(this).data("variant-id") == 42525587439705 ||
      $(this).data("variant-id") == 42525587898457
    ) {
      // Trade Alerts Explorer or Verified AI Day Trade Alerts
      setTimeout(function () {
        $(".jsBtnCheckout").attr("disabled", "disabled");
      }, 2000);
    }
    var t = $(this).data("variant-id");
    console.log("trade alerts explorer", t);
  });
}

$(function () {
  "use strict";

  // Cart Item Update
  $("html").on("click", ".jsItemUpdate", function () {
    updateItem($(this));
  });

  // Cart Item Remove
  $("html").on("click", ".jsItemRemove", function () {
    removeItem($(this));
  });

  $("html").on("click", ".jsItemRemove-redirect", function () {
    var removeURL = $(this).data("url-remove");
    var redirectURL = $(this).data("url-redirect");

    $.get(removeURL).done(function (data) {
      window.location.href = redirectURL;
    });
  });

  goToCheckout();
  checkTradeAlertsExplorer();

  //checkCartItemALDTR();

  //chataddon_popup();
});
